import { BroadcastTimer } from "@layout/Topbar/BroadcastTimer";

import { MessengerContainer } from "@features/messenger/MessengerContainer";

import { Image } from "@components/Image";
import { Stack } from "@components/Stack";

import { useLayoutBreakpoint } from "@hooks/useLayoutBreakpoint";

import { useMessengerStore } from "@storage/global/useMessengerStore";

import { cn } from "@lib/utils";

import { ICON_PATHS } from "@configs/icons";

import { NewsListContainer } from "./NewsListContainer";
import { UserAvatar } from "./UserAvatar";
import { UserBalance } from "./UserBalance";

export const UserBar = () => {
	const { isAuthMessenger } = useMessengerStore();
	const { DESKTOP, MAX_DESKTOP, MOBILE_SMALL } = useLayoutBreakpoint();
	const isDesktop = DESKTOP || MAX_DESKTOP;

	return (
		<Stack
			direction="row"
			justify={isDesktop ? "between" : "end"}
			align="center"
			className={cn("max-h-10 w-full", isDesktop ? "mb-6" : "")}
		>
			{!isDesktop ? <BroadcastTimer /> : null}
			{MOBILE_SMALL ? null : <UserBalance />}

			<Stack direction="row" spacing={5} align="center" className="relative">
				{isAuthMessenger ? (
					<MessengerContainer />
				) : (
					<Image width={40} height={40} src={ICON_PATHS.MSG_ICON} alt="msg_icon" />
				)}
				{MOBILE_SMALL ? null : <NewsListContainer />}
				<UserAvatar />
			</Stack>
		</Stack>
	);
};
